// Material Kit 2 React pages
import WebinarVideos from "pages/WebinarVideos";

export default function WebinarVideosPage() {
  return <WebinarVideos />;
}
